import { parse } from './parser';
import { evaluate } from './evaluator';

export function renderTemplate(templateHtml: string, data: object): string {
  const nodes = parse(templateHtml);

  return evaluate(nodes, data);
}
